import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=fbde27dc&scoped=true"
var script = {}
import style0 from "./Empty.vue?vue&type=style&index=0&id=fbde27dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbde27dc",
  null
  
)

export default component.exports